module.exports = __webpack_public_path__ + "static/media/note2.91ae6975.wav";